module.exports = __webpack_public_path__ + "static/kenneth-faller-83ad3bcc96eacd6b151e529414f2e9e9.jpg";